var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMadisonsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.695,
    height: 20.322,
    viewBox: "0 0 153.695 20.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.472 150.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-159.472 -146.681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-159.472-141.032h3.433l4.765,6.752,4.787-6.752h3.387v15.807h-3.251v-10.929l-4.946,6.819-4.923-6.819v10.929h-3.252Z",
    transform: "translate(159.472 141.303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.228-141.032h3.884l5.713,15.807h-3.658l-.993-2.958h-6.007l-.971,2.958h-3.681Zm-.2,10.207h4.268l-2.123-6.413h-.045Z",
    transform: "translate(131.23 141.303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.178-141.032h5.194c5.645,0,8.693,2.913,8.693,7.836,0,5.035-2.845,7.971-8.693,7.971h-5.194ZM-53.736-128c3.32,0,4.99-1.965,4.99-5.171,0-3.094-1.784-5.081-4.99-5.081h-2.032V-128Z",
    transform: "translate(103.417 141.303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.462-141.032h3.433v15.807h-3.433Z",
    transform: "translate(76.748 141.303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.714-129.7a9.424,9.424,0,0,0,4.652,1.422c1.693,0,2.574-.7,2.574-1.716,0-2.958-8.536-.971-8.536-6.955,0-2.6,2.145-4.7,5.8-4.7a13.014,13.014,0,0,1,5.69,1.333l-1.265,2.687a9.574,9.574,0,0,0-4.268-1.038c-1.513,0-2.416.723-2.416,1.671,0,2.913,8.536.858,8.536,6.955,0,2.665-2.032,4.742-6.1,4.742a12.629,12.629,0,0,1-6.3-1.738Z",
    transform: "translate(63.585 141.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.188-141.646a7.844,7.844,0,0,1,8.2,8.129,7.891,7.891,0,0,1-8.2,8.219,7.9,7.9,0,0,1-8.2-8.219A7.856,7.856,0,0,1,63.188-141.646Zm0,13.458c2.778,0,4.742-2.1,4.742-5.329,0-3.161-1.942-5.262-4.742-5.262-2.778,0-4.719,2.1-4.719,5.262C58.469-130.288,60.433-128.188,63.188-128.188Z",
    transform: "translate(39.606 141.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.491-141.032h3.252l7.046,10.41v-10.41h3.229v15.807h-3.229l-7.046-10.365v10.365h-3.252Z",
    transform: "translate(9.705 141.303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.492-129.7a9.422,9.422,0,0,0,4.651,1.422c1.694,0,2.574-.7,2.574-1.716,0-2.958-8.535-.971-8.535-6.955,0-2.6,2.145-4.7,5.8-4.7a13.015,13.015,0,0,1,5.691,1.333l-1.265,2.687a9.576,9.576,0,0,0-4.268-1.038c-1.512,0-2.416.723-2.416,1.671,0,2.913,8.536.858,8.536,6.955,0,2.665-2.032,4.742-6.1,4.742a12.63,12.63,0,0,1-6.3-1.738Z",
    transform: "translate(-19.568 141.646)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.446-146.194l-2.263-4.087a.252.252,0,0,1,.221-.374h4.526a.252.252,0,0,1,.221.374l-2.263,4.087A.252.252,0,0,1,148.446-146.194Z",
    transform: "translate(-170.816)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadisonsLogo);
export default __webpack_public_path__ + "static/media/madisons-logo.00badd77a83035d441e3129b3b61b0ec.svg";
export { ForwardRef as ReactComponent };